import { get, post, put, del } from "../api_helper"
import { getApiConfig } from "../authHelper"

const CUSTOMER_SUPPORT = "/customer-support"

export const getSupportContacts = () => get(CUSTOMER_SUPPORT, getApiConfig())
export const createSupportContact = data => post(CUSTOMER_SUPPORT, data, getApiConfig())
export const updateSupportContact = (id, data) => put(`${CUSTOMER_SUPPORT}/${id}`, data, getApiConfig())
export const deleteSupportContact = id => del(`${CUSTOMER_SUPPORT}/${id}`, getApiConfig())
